import React from "react";
import "../assets/styles/_button.scss";
import { Link } from "react-router-dom";

type Props = {
  text: string;
  href: string;
  marginTop?: string;
};

export const Button = (props: Props): React.ReactElement => {
  return (
    <Link
      to={props.href}
      className="button"
      style={{ marginTop: props.marginTop ? props.marginTop : "" }}
    >
      {props.text}

      <img src="../images/button-arrow.png" alt="" className="icon" />
    </Link>
  );
};
